import { render, staticRenderFns } from "./SummaryGauge.vue?vue&type=template&id=25a52a47"
import script from "./SummaryGauge.vue?vue&type=script&lang=js"
export * from "./SummaryGauge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports